import { ReducersTypes } from "constants/ReducersTypes";

const initialState = {
  list: [],
  totalCount: 0,
  isFetching: false,
  filters: {
    page: 1,
    perPage: 20,
    prevPage: null,
    nextPage: null,
    totalPages: 0,
    severity: "",
    type: "",
    is_resolved: false,
  },
};

const creditAlerts = (state = initialState, action) => {
  switch (action.type) {
    case ReducersTypes.CREDIT_ALERT_LIST:
      return { ...state, ...action.payload };
    case ReducersTypes.CREDIT_ALERT_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };
    case ReducersTypes.RESET_CREDIT_ALERT_LIST:
      return { ...initialState };
    default:
      return state;
  }
};

export default creditAlerts;
